import { Component, OnInit } from '@angular/core';

import { RouterModule } from '@angular/router';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { ModuloEnum } from '../../../shared/enums/usuario/modulo.enum';
import { FuncionalidadeEnum } from '../../../shared/enums/usuario/funcionalidade.enum';
import { HeaderComponent } from '../../../shared/components/header/header.component';
import { EmptyListComponent } from '../../../shared/components/empty-list/empty-list.component';
import { MatButton, MatIconButton } from '@angular/material/button';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-config-cadastros',
  standalone: true,
  imports: [
    RouterModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatTabsModule,
    HeaderComponent,
    EmptyListComponent,
    MatIcon,
    MatIconButton,
    ReactiveFormsModule,
  ],
  templateUrl: './config-cadastros.component.html',
  styleUrls: ['./config-cadastros.component.css'],
})
export class ConfigCadastrosComponent implements OnInit {
  public moduloEnum = ModuloEnum.Configuracoes;
  public funcionalidadeEnum = FuncionalidadeEnum.Configuracoes_Cadastros;

  public menuGroups = [
    {
      title: 'Cadastros',
      items: [
        { label: 'Cadastro de pessoas', route: 'pessoas', icon: 'groups' },
        { label: 'Cadastro de produtos', route: 'produtos', icon: 'inventory_2' },
        { label: 'Campos obrigatórios', route: 'campos-obrigatorios', icon: 'rule' },
      ],
    },
    {
      title: 'Classificações',
      items: [
        { label: 'Tags', route: 'tags', icon: 'sell' },
        { label: 'Marcas', route: 'marcas', icon: 'verified' },
        { label: 'Unidades de medida', route: 'unidades-medida', icon: 'straighten' },
        { label: 'Variações de produtos', route: 'variacoes', icon: 'tune' },
        { label: 'Atributos de produtos', route: 'atributos-produtos', icon: 'category' },
        { label: 'Linhas de produtos', route: 'linha-produtos', icon: 'view_list' },
      ],
    },
    {
      title: 'Cadastros Fiscais',
      items: [
        { label: 'Tipos Tributários', route: 'tipos-tributarios', icon: 'account_balance' },
      ],
    },
    {
      title: 'Comercial',
      items: [{ label: 'Lista de preço', route: 'lista-precos', icon: 'price_change' }],
    },
  ];

  public filteredMenuGroups = [...this.menuGroups];
  public pesquisaControl = new FormControl('');

  ngOnInit(): void {
    this.pesquisaControl.valueChanges.subscribe(() => {
      this.filtrar();
    });
    this.filtrar(); // Ensure initial state
  }

  public filtrar() {
    const termo = this.removeAcentos(this.pesquisaControl.value?.toLowerCase() || '');
    if (!termo) {
      this.filteredMenuGroups = [...this.menuGroups];
    } else {
      this.filteredMenuGroups = this.menuGroups
        .map(group => ({
          ...group,
          items: group.items.filter(item =>
            this.removeAcentos(item.label.toLowerCase()).includes(termo)
          ),
        }))
        .filter(group => group.items.length > 0);
    }
  }

  private removeAcentos(str: string): string {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }
}
